/* tslint:disable */
/* eslint-disable */
/**
 * Muisti API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DynamicPageResourceDataSource {
    UserValue = 'UserValue'
}

export function DynamicPageResourceDataSourceFromJSON(json: any): DynamicPageResourceDataSource {
    return DynamicPageResourceDataSourceFromJSONTyped(json, false);
}

export function DynamicPageResourceDataSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicPageResourceDataSource {
    return json as DynamicPageResourceDataSource;
}

export function DynamicPageResourceDataSourceToJSON(value?: DynamicPageResourceDataSource | null): any {
    return value as any;
}

